<template>
    <section class="section federations is-full-height-with-navbar">
        <FederationSettings v-if="canManageFederation" />
        <div v-else class="container">
            <h1 class="title mb-2">
                <span>{{ federationName }}</span>
            </h1>
            <a :href="urls.federations().listing()">
                <span class="icon">
                    <i class="fa fa-arrow-left" />
                </span>
                <span>{{ translate("federation.back_to_listing") }}</span>
            </a>
            <div class="notification is-warning is-light mt-5">
                <p>{{ translate("federation.role_cannot_manage") }}</p>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import FederationSettings from "./Dashboard/FederationSettings.vue";
    import { useFederationDashboardStore } from "./Dashboard/federationManagementStore";
    import { useScrollResetOnMount } from "../Common/useScrollResetOnMount";
    import { translate } from "../Common/translations";
    import { FederationRole, FederationRoleEnum } from "../Api/federationsApi";
    import urls from "../Urls/urls";

    useScrollResetOnMount();

    const props = defineProps<{
        federationId: string;
        federationName: string;
        userId: number;
        userRole: FederationRole;
    }>();

    const store = useFederationDashboardStore();

    store.userId = props.userId;
    store.federationId = props.federationId;

    const canManageFederation = computed(
        () => props.userRole === FederationRoleEnum.Owner || props.userRole === FederationRoleEnum.FullOrganizer,
    );
</script>

<style scoped></style>
